import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swb-estate-agents',
  templateUrl: './estate-agents.component.html'
})
export class EstateAgentsComponent implements OnInit {

  public query: string;

  @Output() filterEvent = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  public filter(query: string): void {
    this.query = query;
  }
}
